import { apiSlice } from "./apiSlice";

export const xeroContactApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    pushCustomersToXero: builder.mutation({
      invalidatesTags: ["Customer"],
      query: ({ ids }) => ({
        url: "/api/customer/v1/customer/push_to_xero/",
        method: "POST",
        body: { ids },
      }),
    }),
    pushSuppliersToXero: builder.mutation({
      invalidatesTags: ["SupplierList", "SupplierDetail"],
      query: ({ ids }) => ({
        url: "/api_supplier/supplier/push_to_xero/",
        method: "POST",
        body: { ids },
      }),
    }),
  }),
});

export const { usePushCustomersToXeroMutation, usePushSuppliersToXeroMutation } =
  xeroContactApiSlice;
